import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { HeaderComponent } from './header.component';

@NgModule({
  declarations: [HeaderComponent],
  exports: [HeaderComponent],
  entryComponents: [HeaderComponent],
  imports: [CommonModule, AngularSvgIconModule]
})
export class HeaderModule {}

export { HeaderComponent };
